/* Contact Talk form — client-side required-field check. The form still posts
   for real to Shopify's native `contact` endpoint (see sections/contact-talk.liquid),
   this just blocks that submit and surfaces the section's custom error banner
   when a required field is left blank, instead of the browser's native
   validation bubble (the form carries novalidate via this element). */
!(function () {
  'use strict';

  customElements.get('contact-talk-form') ||
    customElements.define(
      'contact-talk-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.errorEl = this.querySelector('[data-contact-talk-error]');
          if (!this.form || !this.errorEl) return;

          this.form.setAttribute('novalidate', 'novalidate');
          this.fields = Array.prototype.slice.call(this.form.querySelectorAll('[required]'));

          this.onSubmit = this.onSubmit.bind(this);
          this.onFieldInput = this.onFieldInput.bind(this);

          this.form.addEventListener('submit', this.onSubmit);
          this.fields.forEach(
            function (field) {
              field.addEventListener('input', this.onFieldInput);
              field.addEventListener('change', this.onFieldInput);
            }.bind(this)
          );
        }

        invalidFields() {
          return this.fields.filter(function (field) {
            return field.value.trim() === '';
          });
        }

        onSubmit(event) {
          var invalid = this.invalidFields();

          this.fields.forEach(function (field) {
            field.closest('.contact-talk__input-wrap').classList.remove('is-invalid');
          });

          if (!invalid.length) {
            this.errorEl.hidden = true;
            return;
          }

          event.preventDefault();
          this.errorEl.hidden = false;

          invalid.forEach(function (field) {
            field.closest('.contact-talk__input-wrap').classList.add('is-invalid');
          });

          invalid[0].focus();
        }

        onFieldInput(event) {
          var wrap = event.target.closest('.contact-talk__input-wrap');
          if (event.target.value.trim() !== '') wrap.classList.remove('is-invalid');

          if (!this.invalidFields().length) this.errorEl.hidden = true;
        }
      }
    );
})();
